import { type GenericListQueryKey, generateInfiniteQueryKey, generateListQueryKey } from '@pba/react-query';
import { nodeUsersFeatureKey } from '../key';
import type { NodeUsersListQueryFilter } from './types';

type NodeUsersListQueryType = GenericListQueryKey<NodeUsersListQueryFilter>;

export const getNodeUsersListQueryKey = (params: NodeUsersListQueryType) =>
  generateListQueryKey({
    prefix: nodeUsersFeatureKey,
  })(params);

export const getNodeUsersInfiniteQueryKey = generateInfiniteQueryKey({
  generateListQueryKey: getNodeUsersListQueryKey,
});

export const getNodeUsersInfiniteWithPatientAndPersonnelQueryKey = (params: NodeUsersListQueryType) => [
  ...getNodeUsersInfiniteQueryKey(params),
  'with-patient-and-personnel',
];
